// @flow

import type { State, Action } from '../types';
import { UPDATE_PASSWORD, UPDATE_PASSWORD_ERROR, UPDATE_PASSWORD_SUCCESS } from './constants';

const initialState: State = {
  requesting: [],
  updatePassword: {
    error: null,
    success: false
  }
};

const removeTag = (tags: Array<string>, removeTag: string) => tags.filter(tag => tag !== removeTag);

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case UPDATE_PASSWORD:
      return {
        ...state,
        requesting: [...state.requesting, 'updatePassword'],
        updatePassword: {
          error: null,
          success: false
        }
      };

    case UPDATE_PASSWORD_ERROR:
      return {
        ...state,
        requesting: removeTag(state.requesting, 'updatePassword'),
        updatePassword: {
          error: action.error,
          success: false
        }
      };

    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
        requesting: removeTag(state.requesting, 'updatePassword'),
        updatePassword: {
          error: null,
          success: true
        }
      };

    default:
      return state;
  }
};

export default reducer;
